import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import Button from '../app/design/Button'
import Card from '../app/design/Card'
import Heading from '../app/design/Heading'
import Label from '../app/design/Label'
import Paragraph from '../app/design/Paragraph'
import LoginLogo from './login-logo.svg?react'

type LoginState = {
    e164: string | undefined
    loginType: string
    isSending: boolean
}

export function LoginPage() {
    const [loginState, setLoginState] = useState<LoginState>({
        e164: undefined,
        loginType: 'sms',
        isSending: false,
    })

    useEffect(() => {
        document.getElementById('root-spinner')?.remove()
    }, [])

    const isMobile = !!navigator.userAgent.match(
        /(iPhone|iPod|Android|BlackBerry|Windows Phone|webOS)/i
    )

    const { pathname } = useLocation()

    return (
        <div className="mx-auto flex h-full max-w-md flex-col items-center bg-gray-100 py-8">
            <LoginLogo />

            {pathname === '/login/code' && (
                <Button
                    intent="tertiaryLink"
                    className="absolute top-8 left-8 p-0"
                    leftIcon={'chevronLeft.medium'}
                    href="/login"
                >
                    Mobile number
                </Button>
            )}

            <div className="mt-10 flex flex-col items-center gap-y-4">
                <Heading size="xl">Sign in</Heading>
                <Paragraph className="text-gray-600">Continue to PocketSuite</Paragraph>
            </div>

            <Card className="my-12 w-[648px]">
                {isMobile ? (
                    <div className="w-full py-10 text-center">
                        <Label>Please sign into your account on a tablet or computer</Label>
                    </div>
                ) : (
                    <Outlet context={{ loginState, setLoginState }} />
                )}
            </Card>

            <Label size="sm" className="text-gray-600">
                Desktop Beta
            </Label>
        </div>
    )
}
